// Misma regla que el PDF (InvoiceLineDetail en api-rebelde): el detalle de la
// línea es texto plano y solo admite negrita con **texto** dentro de una misma
// línea. Los saltos de línea los respeta el `white-space: pre-line` de la celda.
const BOLD_PATTERN = /\*\*([^\s*](?:[^*\r\n]*[^\s*])?)\*\*/g;

const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;',
};

export function invoiceLineDetailToHtml(detail) {
  if (!detail) {
    return '';
  }

  return detail
    .trim()
    .replace(/[&<>"']/g, char => HTML_ESCAPES[char])
    .replace(BOLD_PATTERN, '<strong>$1</strong>');
}
